import React from 'react'
import TagBrandPage from './TagBrandPage'
import queryString from 'query-string'

const TagBrandPageContainer = (props) => {
    const { history } = props
    const { location } = history
    let params = {}

    if (location.search !== '') {
        const query = queryString.parse(location.search)
        params = query

        if (query.material_code !== undefined) params.material_code = [query.material_code]
    }

    return (
        <div className='TagBrandPageContainer'>
            <TagBrandPage params={params}/>
        </div>
    )
}

export default TagBrandPageContainer